<smart-cart-form-editor-shell [formGroup]="formGroup">
  <smart-cart-form-token-section [token]="usageToken"></smart-cart-form-token-section>

  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <div class="card__title-block">
          <pdq-heading element="h5">Code Types</pdq-heading>
          <span class="card__subtitle">Define which type of codes you want to accept</span>
        </div>
        <div class="card__actions">
          <pdq-button
            class="collapse-chevron"
            [class.collapse-chevron--open]="codeTypesExpanded"
            icon="arrow_down"
            variant="ghost"
            plain="true"
            size="large"
            iconColor="var(--on-surface-default)"
            (onClick)="toggleCodeTypes()"></pdq-button>
        </div>
      </div>
      @if (codeTypesExpanded) {
        <pdq-divider></pdq-divider>
        <div class="card__content">
          <div class="toggle-row">
            <span class="toggle-row__label">Discount codes</span>
            <pdq-slide-toggle [formControl]="formGroup.controls.discountCodesEnabled"></pdq-slide-toggle>
          </div>
          <div class="toggle-row">
            <span class="toggle-row__label">Gift card codes</span>
            <pdq-slide-toggle [formControl]="formGroup.controls.giftCardCodesEnabled"></pdq-slide-toggle>
          </div>
        </div>
      }
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <div class="card__title-block">
          <pdq-heading element="h5">Labels</pdq-heading>
        </div>
        <div class="card__actions">
          <pdq-button
            class="collapse-chevron"
            [class.collapse-chevron--open]="labelsExpanded"
            icon="arrow_down"
            variant="ghost"
            plain="true"
            size="large"
            iconColor="var(--on-surface-default)"
            (onClick)="toggleLabels()"></pdq-button>
        </div>
      </div>
      @if (labelsExpanded) {
        <pdq-divider></pdq-divider>
        <div class="card__content">
          <div class="field">
            <span class="field__label">Title</span>
            <pdq-input
              [formControl]="formGroup.controls.title"
              placeholder="Enter your discount code or gift card"></pdq-input>
          </div>
          <div class="field">
            <span class="field__label">Header Label</span>
            <pdq-input [formControl]="formGroup.controls.headerLabel" placeholder="Discount Code"></pdq-input>
          </div>
          <div class="field">
            <span class="field__label">Button Label</span>
            <pdq-input [formControl]="formGroup.controls.buttonLabel" placeholder="Apply"></pdq-input>
          </div>
          <div class="subsection">
            <div class="subsection__header">
              <span class="subsection__title">DESIGN</span>
              <pdq-button
                class="collapse-chevron"
                [class.collapse-chevron--open]="designExpanded"
                icon="arrow_down"
                variant="ghost"
                plain="true"
                size="large"
                iconColor="var(--on-surface-default)"
                (onClick)="toggleDesign()"></pdq-button>
            </div>
            @if (designExpanded) {
              <div class="subsection__content">
                <div class="field">
                  <div class="field__label-row">
                    <span class="field__label">Background Color</span>
                    @if (backgroundColorOverridden()) {
                      <pdq-link
                        label="Reset to global color"
                        size="small"
                        (onClick)="resetToGlobal(formGroup.controls.design.controls.backgroundColor)"></pdq-link>
                    }
                  </div>
                  <pdq-input-color [formControl]="displayBackgroundColor"></pdq-input-color>
                </div>
                <div class="field">
                  <div class="field__label-row">
                    <span class="field__label">Text Color</span>
                    @if (textColorOverridden()) {
                      <pdq-link
                        label="Reset to global color"
                        size="small"
                        (onClick)="resetToGlobal(formGroup.controls.design.controls.textColor)"></pdq-link>
                    }
                  </div>
                  <pdq-input-color [formControl]="displayTextColor"></pdq-input-color>
                </div>
                <div class="field">
                  <div class="field__label-row">
                    <span class="field__label">Hover Color</span>
                    @if (hoverColorOverridden()) {
                      <pdq-link
                        label="Reset to global color"
                        size="small"
                        (onClick)="resetToGlobal(formGroup.controls.design.controls.hoverColor)"></pdq-link>
                    }
                  </div>
                  <pdq-input-color [formControl]="displayHoverColor"></pdq-input-color>
                </div>
                <div class="field">
                  <div class="field__label-row">
                    <span class="field__label">Corner Radius</span>
                    @if (cornerRadiusOverridden()) {
                      <pdq-link
                        label="Reset to global number"
                        size="small"
                        (onClick)="resetToGlobal(formGroup.controls.design.controls.cornerRadius)"></pdq-link>
                    }
                  </div>
                  <pdq-input-arrows
                    [formControl]="displayCornerRadius"
                    [min]="0"
                    widthSize="fullwidth"></pdq-input-arrows>
                </div>
              </div>
            }
          </div>
          <div class="field">
            <span class="field__label">Discount Invalid Message</span>
            <pdq-input
              [formControl]="formGroup.controls.invalidMessage"
              [placeholder]="'{entered_code} is not valid for this cart'"></pdq-input>
            <span class="field__hint">Message shown when an invalid discount code is entered.</span>
            <span class="field__hint">Dynamic field available - {{ '{entered_code}' }}</span>
          </div>
        </div>
      }
    </div>
  </pdq-card>

  <smart-cart-form-custom-code
    [enabledControl]="formGroup.controls.customCode.controls.enabled"
    [codeControl]="formGroup.controls.customCode.controls.code"
    [defaultCode]="starterTemplate"
    [variables]="customCodeVariables"></smart-cart-form-custom-code>
</smart-cart-form-editor-shell>
